module.exports = __webpack_public_path__ + "d308073b/img/question-icon.06c20c5d.svg";